const FacebookColor = "#1877F2";

import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => ({
  button: {
    background: FacebookColor,
    "&:active": {
      background: "#0C6EEC"
    },
    "&:disabled": {
      opacity: 0.5
    },
    "&:hover": {
      background: "#2B95FF"
    },
    "& svg": {
      color: theme.busbud.colors.background.primary.opaque
    }
  }
}));
